"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventStatusEnum = void 0;
var EventStatusEnum;
(function (EventStatusEnum) {
  /** Свободное время */
  EventStatusEnum[EventStatusEnum["available"] = 1] = "available";
  /** Занят */
  EventStatusEnum[EventStatusEnum["busy"] = 2] = "busy";
  /**
   * Рабочее время (из регулярного расписания)
   *
   * @see RegularSchedule
   */
  EventStatusEnum[EventStatusEnum["regular"] = 3] = "regular";
  /** Не рабочий час */
  EventStatusEnum[EventStatusEnum["day_off"] = 4] = "day_off";
  /**
   * Отпуск (из регулярного расписания)
   *
   * @see UserVacation
   */
  EventStatusEnum[EventStatusEnum["vacation"] = 5] = "vacation";
  /** Для курсов - запланированное событие */
  EventStatusEnum[EventStatusEnum["course_reservations"] = 6] = "course_reservations";
  /** Для регулярных занятий - запланированное (фантомное) событие */
  EventStatusEnum[EventStatusEnum["ongoing_reservations"] = 7] = "ongoing_reservations";
  /** требуется подтверждение хотя бы одним участником */
  EventStatusEnum[EventStatusEnum["accept_required"] = 0] = "accept_required";
  /** требуется подтверждение отмены */
  EventStatusEnum[EventStatusEnum["cancel_required"] = 10] = "cancel_required";
  /** отменён */
  EventStatusEnum[EventStatusEnum["canceled"] = 20] = "canceled";
  /** требуется подтверждение переноса времени */
  EventStatusEnum[EventStatusEnum["reschedule_required"] = 30] = "reschedule_required";
  /** подтвёрждён мной */
  EventStatusEnum[EventStatusEnum["accepted"] = 40] = "accepted";
  /** занятие запущено */
  EventStatusEnum[EventStatusEnum["started"] = 50] = "started";
  /** занятие завершено */
  EventStatusEnum[EventStatusEnum["finished"] = 60] = "finished";
})(EventStatusEnum = exports.EventStatusEnum || (exports.EventStatusEnum = {}));
